import { createActionGroup, props } from '@ngrx/store';
import { AiReviewStatus, BackgroundJobCreatedDto, CreateLocationDto, LocationDto, UpdateLocationDto } from '@travel-planner/library-travel-planner-api';
import { NavigationDescription } from '../../../../core/models/navigation-description';
import { ApiError } from '../../../../core/models/api-error';
import { ImageUploadItem, ImageUrlUploadItem } from '../../../../core/models/image-upload';

export const LocationsActions = createActionGroup({
    source: 'Locations',
    events: {
        'Load Locations': props<{
            searchTerm: string;
            country?: string | undefined;
            lastLocationId?: number | undefined;
            includeTotal: boolean;
            aiGenerationJobId?: string | undefined;
            aiGenerated?: boolean | undefined;
            aiReviewStatus?: AiReviewStatus | undefined;
        }>(),
        'Load Locations Success': props<{ locations: LocationDto[]; total?: number | undefined }>(),
        'Load Locations Failure': props<{ error: ApiError }>(),
        'Load Location': props<{ id: string }>(),
        'Load Location Success': props<{ location: LocationDto }>(),
        'Load Location Failure': props<{ id: string; error: ApiError }>(),
        'Add Location': props<{ locationToAdd: CreateLocationDto }>(),
        'Add Location Success': props<{ location: LocationDto; navigateOnSuccess?: NavigationDescription }>(),
        'Add Location Failure': props<{ error: ApiError }>(),
        'Update Location': props<{ id: number; locationToUpdate: UpdateLocationDto; navigateOnSuccess?: NavigationDescription }>(),
        'Update Location Success': props<{ updatedLocation: LocationDto; navigateOnSuccess?: NavigationDescription }>(),
        'Update Location Failure': props<{ id: number; error: ApiError }>(),
        'Delete Location': props<{ id: number }>(),
        'Delete Location Success': props<{ id: string; navigateOnSuccess?: NavigationDescription }>(),
        'Delete Location Failure': props<{ id: number; error: ApiError }>(),
        'Create Multiple Locations From User Prompt': props<{ prompt: string }>(),
        'Create Multiple Locations From User Prompt Success': props<{ job: BackgroundJobCreatedDto }>(),
        'Create Multiple Locations From User Prompt Failure': props<{ error: ApiError }>(),
        'Approve Ai Generated Content': props<{ id: number }>(),
        'Approve Ai Generated Content Success': props<{ location: LocationDto }>(),
        'Approve Ai Generated Content Failure': props<{ id: number; error: ApiError }>(),

        // Images
        'Upload Location Images': props<{ id: number; files: ImageUploadItem[] }>(),
        'Upload Location Image Urls': props<{ id: number; urls: ImageUrlUploadItem[] }>(),
        'Upload Location Images Success': props<{ updatedLocation: LocationDto }>(),
        'Upload Location Images Failure': props<{ id: number; error: ApiError }>(),
        'Delete Location Image': props<{ locationId: number; imageId: number }>(),
        'Delete Location Image Success': props<{ locationId: number; imageId: number }>(),
        'Delete Location Image Failure': props<{ id: number; imageId: number; error: ApiError }>(),
        'Reorder Location Images': props<{ locationId: number; imageId: number; newIndex: number }>(),
        'Reorder Location Images Success': props<{ updatedLocation: LocationDto }>(),
        'Reorder Location Images Failure': props<{ id: number; error: ApiError }>(),
    }
});
